import { create } from "zustand";
import type { MentionPersonSuggestion } from "../schema";

export type OpenInviteCollaboratorOptions = {
	person: MentionPersonSuggestion;
	targetTitle?: string;
	anchorRect?: { x: number; y: number } | null;
	whiteboardId?: string;
	cardId?: string;
	onConfirmed?: (granted: boolean) => void;
	onCancel?: () => void;
	onInvite?: (role: "editor" | "viewer") => Promise<void>;
};

type InviteStore = {
	isOpen: boolean;
	options: OpenInviteCollaboratorOptions | null;
	open: (options: OpenInviteCollaboratorOptions) => void;
	close: () => void;
};

export const useInviteCollaboratorStore = create<InviteStore>((set) => ({
	isOpen: false,
	options: null,
	open: (options) => set({ isOpen: true, options }),
	close: () => set({ isOpen: false, options: null }),
}));

export function openInviteCollaboratorModal(
	options: OpenInviteCollaboratorOptions,
) {
	useInviteCollaboratorStore.getState().open(options);
}
